@if (eventModel && eventModel.ID > 0) {
    <div class="detail-page-summary">
        <div class="row">
            <div class="col-6">
                <div class="property"><b>{{ 'event.detailMain.summaryId' | transloco }}</b> {{ eventModel.Identifier }}</div>
                <div class="property">
                    <b>{{ 'event.detailMain.summaryName' | transloco }}</b> &nbsp;<span data-uiid="event-name-label">{{
                        eventModel.Name
                    }}</span>
                </div>
                <div class="property">
                    <b>{{ 'event.detailMain.summaryRegistrationDate' | transloco }}</b> {{ eventModel.DateCreated | dateFormat }}
                </div>
            </div>
            <div class="col-6">
                <div class="property">
                    <b>{{ 'event.detailMain.summaryDateOccurred' | transloco }}</b> {{ eventModel.DateOccurrence | dateFormat }}
                </div>
                <div class="property">
                    <b>{{ 'event.detailMain.summaryDateDetected' | transloco }}</b> {{ eventModel.DateDetection | dateFormat }}
                </div>
                <div class="property">
                    <b>{{ 'event.detailMain.summaryDateClosed' | transloco }}</b> {{ eventModel.DateClosed | dateFormat }}
                </div>
            </div>
        </div>
    </div>
}

<event-comments [eventGuid]="eventModel.Guid" #comments> </event-comments>

@if (eventModel) {
    <form [formGroup]="parentForm">
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'event.detailMain.eventDetailsTitle' | transloco }}</div>
            <div class="detail-page-card-body padded">
                @if (sdHeavy) {
                    <div>
                        <div class="row">
                            <div class="col-12 col-xl-6 left-block">
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textfield
                                            fieldLabel="{{ 'event.detailMain.eventNameFieldLabel' | transloco }}"
                                            dataUiid="event-name"
                                            identifier="eventNameInput"
                                            formControlName="Name"
                                            placeholder="Required"
                                        ></cerrix-textfield>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col separator">
                                        <cerrix-textfield
                                            fieldLabel="{{ 'event.detailMain.internalIdentifierFieldLabel' | transloco }}"
                                            dataUiid="event-identifier"
                                            identifier="internalIdentifierInput"
                                            formControlName="InternalIdentifier"
                                        ></cerrix-textfield>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="form-group">
                                    <label for="organizationSelect">{{ 'event.detailMain.organizationLabel' | transloco }}</label>
                                    <cerrix-select-tree
                                        data-uiid="event-organization"
                                        [tree]="sdHeavy.Organizations"
                                        formControlName="OrganizationId"
                                        placeholder="Required"
                                        [multiselect]="false"
                                        (onChangeSingleId)="reloadBusinessData()"
                                    >
                                    </cerrix-select-tree>
                                </div>
                                <div class="form-group">
                                    <label for="organizationCauserSelect"
                                        >{{ 'event.detailMain.causedByOrganizationLabel' | transloco }}</label
                                    >
                                    <cerrix-select-tree
                                        data-uiid="event-causedbyorganization"
                                        [tree]="sdHeavy.Organizations"
                                        formControlName="CausedByOrganizationId"
                                        [multiselect]="false"
                                    >
                                    </cerrix-select-tree>
                                </div>

                                <div class="row">
                                    <div class="form-group col separator">
                                        <label for="organizationSelect"
                                            >{{ 'event.detailMain.affectedOrganizationLabel' | transloco }}</label
                                        >
                                        <cerrix-select-tree
                                            data-uiid="event-affectedorganization"
                                            [tree]="sdHeavy.Organizations"
                                            formControlName="AffectedOrganizationId"
                                            [multiselect]="false"
                                        >
                                        </cerrix-select-tree>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="form-group">
                                    <label for="businessDimenionTree">
                                        {{ 'event.detailMain.businessDimensionsLabel' | transloco }}
                                        @if (!selectedOrganizationId) {
                                            <i
                                                class="far fa-question-circle ms-2"
                                                [matTooltip]="
                                                    'Please select an organization first.'
                                                "
                                            ></i>
                                        }
                                    </label>
                                    <cerrix-select-tree
                                        data-uiid="event-businessdimension"
                                        [(tree)]="businessDimensions"
                                        formControlName="BusinessDimensions"
                                        [multiselect]="true"
                                        [readonly]="!selectedOrganizationId"
                                    >
                                    </cerrix-select-tree>
                                </div>
                                <div class="form-group">
                                    <label for="businessLineSelect">{{ 'event.detailMain.businessLineLabel' | transloco }}</label>
                                    <ng-select
                                        data-uiid="event-businessline"
                                        id="businessLineSelect"
                                        name="businessLineSelect"
                                        [items]="sdHeavy.BusinessLines"
                                        formControlName="BusinessLineId"
                                        bindLabel="Name"
                                        bindValue="ID"
                                        [closeOnSelect]="true"
                                        [multiple]="false"
                                    >
                                    </ng-select>
                                </div>
                            </div>

                            <div class="col-12 col-xl-6 right-block">
                                <div class="form-group-separator d-xl-none"></div>

                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="dateOccurredInput">{{ 'event.detailMain.dateOccurredLabel' | transloco }}</label>
                                            <date-input
                                                data-uiid="event-dateoccured"
                                                formControlName="DateOccurrence"
                                                [maxDate]="maxDate"
                                            ></date-input>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="dateDetectedInput">{{ 'event.detailMain.dateDetectedLabel' | transloco }}</label>
                                            <date-input
                                                data-uiid="event-datedetected"
                                                formControlName="DateDetection"
                                                [maxDate]="maxDate"
                                            ></date-input>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="form-group">
                                    <label for="eventCategorySelect">{{ 'event.detailMain.eventCategoryLabel' | transloco }}</label>
                                    <cerrix-select-tree
                                        data-uiid="event-category"
                                        [tree]="sdHeavy.EventCategories"
                                        formControlName="EventCategoryId"
                                        [multiselect]="false"
                                    >
                                    </cerrix-select-tree>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="incidentTypeSelect">{{ 'event.detailMain.incidentTypeLabel' | transloco }}</label>
                                            <ng-select
                                                data-uiid="event-incidenttype"
                                                id="incidentTypeSelect"
                                                name="incidentTypeSelect"
                                                [items]="sdHeavy.IncidentTypes"
                                                formControlName="IncidentTypes"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                                placeholder="Required"
                                                [multiple]="true"
                                            >
                                            </ng-select>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="classificationSelect">{{ 'event.detailMain.classificationLabel' | transloco }}</label>
                                            <ng-select
                                                data-uiid="event-classification"
                                                id="classificationSelect"
                                                name="classificationSelect"
                                                [items]="sdHeavy.Classifications"
                                                formControlName="ClassificationId"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="true"
                                            >
                                                <ng-template
                                                    ng-label-tmp
                                                    ng-option-tmp
                                                    let-item="item"
                                                >
                                                    <div
                                                        [style.background-color]="item.Color"
                                                        style="
                                                            min-width: 5px;
                                                            min-height: 22px;
                                                            float: left;
                                                            margin-right: 10px;
                                                        "
                                                    ></div>
                                                    {{ item.Name }}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="row">
                                    <div class="form-group col">
                                        <label for="reporterSelect">{{ 'event.detailMain.reporterLabel' | transloco }}</label>
                                        @if (canChangeReporter) {
                                            <ng-select
                                                id="reporterSelect"
                                                name="reporterSelect"
                                                [items]="sdHeavy.Reporter"
                                                formControlName="ReportedById"
                                                bindLabel="Name"
                                                bindValue="ID"
                                                [closeOnSelect]="false"
                                            >
                                            </ng-select>
                                        } @else {
                                            <cerrix-textfield
                                                dataUiid="event-reporter"
                                                id="reportInput"
                                                formControlName="ReporterName"
                                            ></cerrix-textfield>
                                        }
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="responsibleSelect">{{ 'event.detailMain.responsiblesLabel' | transloco }}</label>
                                        <ng-select
                                            data-uiid="event-responsibles"
                                            id="responsibleSelect"
                                            name="responsibleSelect"
                                            [items]="sdHeavy.Responsibles"
                                            formControlName="Responsible"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                            [multiple]="true"
                                            placeholder="Required"
                                        >
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="assessorSelect">{{ 'event.detailMain.assessorsLabel' | transloco }}</label>
                                        <ng-select
                                            data-uiid="event-assessors"
                                            id="assessorSelect"
                                            name="assessorSelect"
                                            [items]="sdHeavy.Assessors"
                                            formControlName="Assessor"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                            [multiple]="true"
                                            placeholder="Required"
                                        >
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="informedSelect">{{ 'event.detailMain.informedLabel' | transloco }}</label>
                                        <ng-select
                                            data-uiid="event-informed"
                                            id="informedSelect"
                                            name="informedSelect"
                                            [items]="sdHeavy.Informed"
                                            formControlName="Informed"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                            [multiple]="true"
                                        >
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </div>

        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'event.detailMain.eventAnalysisTitle' | transloco }}</div>
            <div class="detail-page-card-body padded cerrix-control-sm">
                @if (sdLight) {
                    <div>
                        <div class="row">
                            <div class="col-12 col-xl-6 left-block">
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'event.detailMain.eventDescriptionFieldLabel' | transloco }}"
                                            dataUiid="event-description"
                                            identifier="eventDescriptionInput"
                                            formControlName="Description"
                                            placeholder="Required"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-12 col-lg-6">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'event.detailMain.impactDescriptionFieldLabel' | transloco }}"
                                            dataUiid="event-impactdescription"
                                            identifier="impactDescriptionInput"
                                            formControlName="ImpactDescription"
                                        ></cerrix-textarea>
                                    </div>
                                    <div class="form-group col-12 col-lg-6">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'event.detailMain.causeDescriptionFieldLabel' | transloco }}"
                                            dataUiid="event-causedescription"
                                            identifier="causeDescriptionInput"
                                            formControlName="CauseDescription"
                                        ></cerrix-textarea>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>
                            </div>
                            <div class="col-12 col-xl-6 right-block">
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'event.detailMain.primaryCauseFieldLabel' | transloco }}"
                                            dataUiid="event-primarycause"
                                            identifier="primaryCauseInput"
                                            formControlName="PrimaryCause"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'event.detailMain.secondaryCauseFieldLabel' | transloco }}"
                                            dataUiid="event-secondarycause"
                                            identifier="secondaryCauseInput"
                                            formControlName="SecondaryCause"
                                        ></cerrix-textarea>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-xl-6 left-block">
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'event.detailMain.effectDescriptionFieldLabel' | transloco }}"
                                            dataUiid="event-effectdescription"
                                            identifier="effectDescriptionInput"
                                            formControlName="EffectDescription"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="effectsSelect">{{ 'event.detailMain.effectsLabel' | transloco }}</label>
                                        <ng-select
                                            data-uiid="event-effects"
                                            id="effectsSelect"
                                            name="effectsSelect"
                                            [multiple]="true"
                                            [items]="sdLight.Effects"
                                            formControlName="Effects"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                        >
                                        </ng-select>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'event.detailMain.reputationImpactDescriptionFieldLabel' | transloco }}"
                                            data-uiid="event-reputationimpactdescription"
                                            identifier="reputationImpactDescInput"
                                            formControlName="ReputationImpactDescription"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="reputationImpactSelect"
                                            >{{ 'event.detailMain.reputationImpactLabel' | transloco }}</label
                                        >
                                        <ng-select
                                            data-uiid="event-reputationimpact"
                                            id="reputationImpactSelect"
                                            name="reputationImpactSelect"
                                            [items]="sdLight.ReputationImpacts"
                                            formControlName="ReputationImpactId"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="true"
                                        >
                                        </ng-select>
                                    </div>
                                </div>

                                <div class="form-group-separator d-xl-none"></div>
                            </div>
                            <div class="col-12 col-xl-6 right-block">
                                <div class="row">
                                    <div class="form-group col-6">
                                        <label for="grossImpactNumber">{{ 'event.detailMain.grossImpactLabel' | transloco }}</label>
                                        <input
                                            data-uiid="event-grossimpact"
                                            type="number"
                                            class="form-control form-control-sm"
                                            id="grossImpactNumber"
                                            name="grossImpactNumber"
                                            formControlName="GrossCosts"
                                            step="0.01"
                                            data-number-to-fixed="2"
                                            data-number-stepfactor="100"
                                            (change)="calculateNetCosts()"
                                        />
                                    </div>
                                    <div class="form-group col-6">
                                        <label for="recoveryNumber">{{ 'event.detailMain.recoveryLabel' | transloco }}</label>
                                        <input
                                            data-uiid="event-recovery"
                                            type="number"
                                            class="form-control form-control-sm"
                                            id="recoveryNumber"
                                            name="recoveryNumber"
                                            formControlName="Recovery"
                                            (change)="calculateNetCosts()"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="netImpactText">{{ 'event.detailMain.nettImpactLabel' | transloco }}</label>
                                        <input
                                            data-uiid="event-nettimpact"
                                            type="number"
                                            class="form-control form-control-sm"
                                            id="netImpactText"
                                            name="netImpactText"
                                            formControlName="NetCosts"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label for="currencySelect">{{ 'event.detailMain.currencyLabel' | transloco }}</label>
                                        <ng-select
                                            data-uiid="event-currency"
                                            id="currencySelect"
                                            name="currencySelect"
                                            formControlName="CurrencyCode"
                                            [items]="sdLight.Currencies"
                                            bindLabel="Name"
                                            bindValue="ID"
                                            [closeOnSelect]="false"
                                        >
                                        </ng-select>
                                    </div>
                                </div>

                                <div class="form-group-separator"></div>

                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'event.detailMain.riskOpinionFieldLabel' | transloco }}"
                                            dataUiid="event-riskopinion"
                                            identifier="riskOpinionInput"
                                            formControlName="RiskOpinion"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <cerrix-textarea
                                            fieldLabel="{{ 'event.detailMain.commentsFieldLabel' | transloco }}"
                                            dataUiid="event-comments"
                                            identifier="commentsInput"
                                            formControlName="Comments"
                                        ></cerrix-textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </div>

        <!-- Custom fields -->
        @if (eventCustomFieldsFormGroup && customFieldStandingDataModel.any()) {
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ 'event.detailMain.customFieldsTitle' | transloco }}</div>
                <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
                    <cerrix-custom-fields-editor
                        [parentForm]="eventCustomFieldsFormGroup"
                        [customFieldData]="customFieldData"
                        [singleColumn]="false"
                    ></cerrix-custom-fields-editor>
                </div>
            </div>
        }
    </form>
}
